import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { TemplateDropdownDetail } from '@troia-v3/types';

export const useTemplateDropdownDetail = (templateId?: string) =>
  useQuery({
    queryKey: ['template-dropdown-detail', templateId],
    queryFn: async () => {
      const res = await api.get(`/templates/dropdown/${templateId}`);
      return res.data.data as TemplateDropdownDetail;
    },
    enabled: !!templateId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
